import React, { lazy } from 'react';
import PrivateRoute from 'PrivateRoutes';
const MCPServer = lazy(()=> import(/* webpackChunkName: "MCPServer" */'./components'));

const routes = () => (
    <PrivateRoute exact path="/settings/mcpServer" component={MCPServer} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/MCPServer/routes.js